<template>
	<div class="ExhibitionHall" >
		<img src="../assets/images/404.svg"style="width: 40%;display: block;margin-left: auto;margin-right: auto;" >
		<p style="font-size: 14px; color: #ccc;text-align: center;">将在{{time}}秒后返回首页</p>
	</div>
</template>
<script>
	export default {
		name: 'ExhibitionHall',
		data() {
			return {
				time:5,
				codetitle_fn:null
			};
		},
		components: {},
		methods: {},
		mounted() {
			this.codetitle_fn = setInterval(() => {
				this.time--
				if (this.time <= 0) {
					this.$router.push('/');
				}
			}, 1000);
			this.$parent.$parent.$refs.PublicHomeHerder.$el.style.display = 'none';
			this.$parent.$parent.$refs.PublicHomeButtom.$el.style.display = 'none';
		},
		destroyed() {
			clearInterval(this.codetitle_fn);
			this.$parent.$parent.$refs.PublicHomeHerder.$el.style.display = 'block'
			this.$parent.$parent.$refs.PublicHomeButtom.$el.style.display = 'block';
		}
	};
</script>
<style scoped>

</style>
